import { Icons } from "../models/assets-files";

interface FileMenuOption {
  id: string;
  title: string;
  icon: string;
  cta: string;
}

export enum FileOptionId {
  VIEW = "view",
  REMOVE = "remove",
}

export const fileMenuOptions: FileMenuOption[] = [
  {
    id: FileOptionId.VIEW,
    title: "View",
    icon: Icons.FileOptions.View,
    cta: FileOptionId.VIEW,
  },
  {
    id: FileOptionId.REMOVE,
    title: "Remove",
    icon: Icons.FileOptions.Remove,
    cta: FileOptionId.REMOVE,
  },
];
